<!--
 * @component
 * Select
 * @property id <String:Unique>
 * @property label <String>
 * @property options <Array:Option{
 *   title <String>
 *   value <String>
 *   selected <Boolean>
 * }>
 * -->
<Field id="{id}" {...$$restProps}>
  <!-- svelte-ignore a11y-no-onchange -->
  <select id="{id}" disabled="{disabled || options.length === 0}" bind:value on:change> <!-- FFG: add option to disable select -->
    {#if !options.some(option => option.selected === true)}<option hidden disabled selected value></option>{/if} <!-- FFG: if no option is selected by default, add empty option -->
    {#each options as option}
      <option
        value="{option.value || option.title || option}"
        selected="{option.selected}"
      >
        {option.title || option}
      </option>
    {:else}
      <option value="null">No options</option>
    {/each}
  </select>
</Field>
<!-- /component -->

<script>
  import Field from './Field.svelte';

  export let id;
  export let options = [];
  export let value;
  export let disabled = undefined; // FFG: add option to disable select
</script>
